module.exports = __webpack_public_path__ + "static/media/delete.d9518d0c.svg";